const mutations = {
	SET_LOGS_LIST (state, data) {
		state.items = []
		state.totalPages = 0
		state.items.push(data.content)
		state.totalElements = data.totalElements
		state.totalPages = data.totalPages
	},
	SET_ITEMS (state, data) {
		state.itemsLogs = JSON.parse(JSON.stringify(data.data)).content
		state.totalPages = JSON.parse(JSON.stringify(data.data)).totalPages
	},
	SET_LOGS (state, data) {
		state.items = []
		state.items.push(data.content)
		state.totalElements = data.totalElements
		state.totalPages = data.totalPages
	},
	SET_USER_ID (state, data) {
    state.idUser = data.data
  },
	SET_SEARCH_EMAIL_FILTER (state, data) {
    state.email = data
  },
	SET_SEARCH_MESSAGE_FILTER (state, data) {
    state.search_message = data
  },
	SET_CURRENT_PAGE (state, data) {
    state.current_page = data
  },
	SET_SERVICE (state, data) {
    state.services = data
  },
  SET_LOGS_TO_EDIT (state, data) {
    const logsInfo = data
    state.logsToEdit = {
		...state.logsToEdit,
		...logsInfo
    }
  },
  UNSET_LOGS_TO_EDIT (state, data) {
    state.logsToEdit = {
			channelType: '',
			dateAdded: '',
			list: '',
			message: '',
			messageType: '',
			moeCampaignName: '',
			name: '',
			produtoSlug: null,
			pushType: null,
			requestJson: '',
			responseJson: '',
			sendTime: null,
			smsContent: '',
			title: '',
			url: null,
		}
  },
	SET_DATE_TO (state, data) {
		state.to = data
	},
	SET_DATE_FROM (state, data) {
		state.from = data
	},
	SET_CHANNEL (state, data) {
		state.channelType = data
	},
	SET_PUSH_LIST(state, data) {
		state.items = data.content;
		state.totalElements = data.totalElements
		state.totalPages = data.totalPages;
		this.loadingClear = false;
	},
	// SET_PUSH_PAGINATION (state, data) {
	// 	let paginationInfo = JSON.parse(JSON.stringify(data))
	// 	if (paginationInfo.total_elements <= 30 ) {
	// 		paginationInfo.total_pages = 1
	// 	} else {
	// 		paginationInfo.total_pages = Math.trunc(paginationInfo.total_elements/30)+1
	// 	}
	// 	state.pagination = {
	// 		...state.pagination,
	// 		...paginationInfo
	// 	}
	// },
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/logs/mutations.js